import { render, staticRenderFns } from "./teacherStar.vue?vue&type=template&id=69c70f4c&scoped=true&"
import script from "./teacherStar.vue?vue&type=script&lang=js&"
export * from "./teacherStar.vue?vue&type=script&lang=js&"
import style0 from "./teacherStar.vue?vue&type=style&index=0&id=69c70f4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c70f4c",
  null
  
)

export default component.exports